export default {
  title: 'Pagar con {{method}}',
  hint: 'A continuación, confirma el pago con tu banco o en tu app.',
  continue: 'Continuar',
  cancel: 'Cancelar pago',
  unavailable: 'Este método de pago no está disponible en este momento. Elige otro.',
};
